import Layout from '@/layout';
var statisticsRouter = {
  path: '/layout',
  component: Layout,
  redirect: '/layout/program-layout',
  name: 'layout',
  alwaysShow: true,
  meta: {
    title: '布局',
    icon: 'clipboard'
  },
  children: [{
    path: 'program-layout',
    component: function component(resolve) {
      return require(['@/views/my-create/my-layout/program-layout/index.vue'], resolve);
    },
    name: 'program-layout',
    meta: {
      title: '小程序布局',
      icon: ''
    }
  }, {
    path: 'shopping-setting',
    component: function component(resolve) {
      return require(['@/views/my-create/my-layout/shopping-setting/index.vue'], resolve);
    },
    name: 'shopping-setting',
    meta: {
      title: '商城配置',
      icon: ''
    }
  }]
};
export default statisticsRouter;